import { render, staticRenderFns } from "./Huddle.vue?vue&type=template&id=4ab30fd7&scoped=true"
import script from "./Huddle.vue?vue&type=script&lang=js"
export * from "./Huddle.vue?vue&type=script&lang=js"
import style0 from "./Huddle.vue?vue&type=style&index=0&id=4ab30fd7&prod&lang=scss"
import style1 from "./Huddle.vue?vue&type=style&index=1&id=4ab30fd7&prod&lang=scss&scoped=true"
import style2 from "./HuddleModern.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab30fd7",
  null
  
)

export default component.exports